import React from 'react'

const Section4 = ({unlock}) => {
    
    return (
        <>
             {/* <!--活動三 集氣活動--> */}
        <section id="event_03" className="event_04">
            <div className="inner_wrap wow fadeInUp">
                <h2>社群集氣同歡 解鎖週年彩蛋</h2>
                <span>活動時間 即日起-7/10 23:59</span>
                <img src="/events/img/line.png" alt="" className="line" />
                <div className="event_tip">
                    <p>精彩追逐不停歇，豐厚謝禮慶週年！<br/><br/>
                        <b className="color_orange">為了感謝偵探們長久以來的支持，《第五人格》 三週年狂歡特別企劃最終部分為大家準備了週年彩蛋大禮！</b>
                        <br/><br/>
                        凡在社群平台 (Facebook、Instagram、Tiktok) 分享週年祝福、遊戲日常、遊戲截圖等等，只要與第五人格遊戲相關的內容，並標記<b className="color_orange">指定hashtag #第五人格三週年快樂</b>。將依貼文數、留言數、分享數等社群討論熱度指標，集氣累積狂歡點數！邀請偵探們一起在社群分享週年盛典狂歡，累積達指定目標即可解鎖週年彩蛋大禮！
                        <br/><br/>
                        <span>偷偷透露線索，據說這些週年彩蛋與一些知名Youtube創作者相關……真是令人期待！</span>
                    </p>
                </div>
                <img src="/events/img/line.png" alt="" className="line" />
                <h3>狂歡點數集氣進度</h3>
                {/* <!--進度條--> */}
                <div className="level_wrap wow fadeInUp">
                    <div className={`level_01 ${Date.now()/1000 > unlock[0] && "on"} `}>人數達到五萬</div>
                    <div className={`level_02 ${Date.now()/1000 > unlock[1] && "on"} `}>人數達到十萬</div>
                    <div className={`level_03 ${Date.now()/1000 > unlock[2] && "on"} `}>人數達到三十萬</div>
                    <div className={`level_04 ${Date.now()/1000 > unlock[3] && "on"} `}>人數達到五十萬</div>
                </div>
            </div>
        </section>
        </>
    )
}

export default Section4
